mutation Inertia_DestroyMember($memberId: ID!) {
  destroyMember(input: { memberId: $memberId }) {
    success
    errors
  }
}